import axios from '../helpers/AxiosInstance';
import {
  LoginPayloadType,
  LoginResponseType,
  Verify2FactorPayloadType,
  Verify2FactorResponseType,
  RefreshTokenResponseType,
  ResetPasswordPayloadType,
} from '../interfaces/Auth';
import { ApplicationCodeEnum } from '../helpers/Constants';

export class AuthApiService {
  static async login(payload: LoginPayloadType) {
    return axios.post<LoginResponseType>('IdentityAdmin/Login', payload);
  }

  static async forgotPassword(email: string, app: string = ApplicationCodeEnum.CONNECT) {
    return axios.post('IdentityAdmin/ForgotPassword', { email, app });
  }

  static async verify2Factor(payload: Verify2FactorPayloadType) {
    return axios.post<Verify2FactorResponseType>('IdentityAdmin/Verify2FA', payload);
  }

  static async resend2Factor(twoFactorToken: string) {
    return axios.post('IdentityAdmin/RegenerateCode', { twoFactorToken });
  }

  static async resetPassword(payload: ResetPasswordPayloadType) {
    return axios.post('IdentityAdmin/ChangePassword', payload);
  }

  static async refreshToken(refreshToken: string) {
    return axios.post<RefreshTokenResponseType>('IdentityAdmin/RefreshToken', { refreshToken });
  }

  static async getCurrentUser() {
    return axios.get('IdentityAdmin/CurrentUser');
  }
}
